module.exports = __webpack_public_path__ + "img/about_2.c371b90c.png";